import 'css-chunksrc/client/pages/occupancyPage/table/loader/row/styles.scss';export default {
  "row": "_row_d0cdn_1",
  "resourceCell": "_resourceCell_d0cdn_6",
  "chevronBox": "_chevronBox_d0cdn_22",
  "avatar": "_avatar_d0cdn_27",
  "identity": "_identity_d0cdn_34",
  "name": "_name_d0cdn_41",
  "profession": "_profession_d0cdn_46",
  "cell": "_cell_d0cdn_51",
  "cellBar": "_cellBar_d0cdn_63"
};